const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query)
        .filter(([_, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code   = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const usersApi = {
  adminList:          (token, opts)            => request('/admin/users',                 { token, query: opts }),
  adminGet:           (token, id)              => request(`/admin/users/${id}`,           { token }),
  adminCreate:        (token, body)            => request('/admin/users',                 { method: 'POST',   token, body }),
  adminUpdate:        (token, id, body)        => request(`/admin/users/${id}`,           { method: 'PATCH',  token, body }),
  adminDelete:        (token, id)              => request(`/admin/users/${id}`,           { method: 'DELETE', token }),
  adminResetPassword: (token, id, newPassword) => request(`/admin/users/${id}/reset-password`, { method: 'POST', token, body: { newPassword } }),
};

export const USER_ROLES = [
  { id: 'admin',         lbl: 'Admin' },
  { id: 'moderateur',    lbl: 'Modérateur' },
  { id: 'contributeur',  lbl: 'Contributeur' },
  { id: 'membre',        lbl: 'Membre' },
];

export const ROLE_LABEL = Object.fromEntries(USER_ROLES.map((r) => [r.id, r.lbl]));

export const ROLE_FILTERS = [
  { id: 'all',           lbl: 'Tous rôles' },
  ...USER_ROLES,
];

export const ACTIVE_FILTERS = [
  { id: 'all', lbl: 'Tous' },
  { id: 'yes', lbl: 'Actifs' },
  { id: 'no',  lbl: 'Suspendus' },
];
